// src/components/Layout.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Layout.css';

const Layout = ({ children }) => {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div>
      <header className="site-header">
        <div className="header-inner">
          <h1 className="site-title">📄 PDF BLINK</h1>

          <button
            className="nav-toggle"
            aria-expanded={navOpen}
            aria-label="Toggle navigation"
            onClick={() => setNavOpen(!navOpen)}
          >
            <span className={`hamburger ${navOpen ? 'open' : ''}`} />
          </button>

          <nav className={`site-nav ${navOpen ? 'open' : ''}`}>
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/text-to-pdf" className="nav-link">Text to PDF</Link>
            <Link to="/merge-pdfs" className="nav-link">Merge PDFs</Link>
            <Link to="/image-to-pdf" className="nav-link">Image to PDF</Link>
            <Link to="/SplitPDF" className="nav-link">Split PDF</Link>
            <Link to="/compress-pdf" className="nav-link">Compress PDF</Link>
            <Link to="/watermark-pdf" className="nav-link">Watermark PDF</Link>
            <Link to="/privacy-policy" className="nav-link">Privacy Policy</Link>
            <Link to="/about-us" className="nav-link">About Us</Link>
            <Link to="/terms" className="nav-link">Terms</Link>
            <Link to="/faqs" className="nav-link">FAQs</Link>
            <Link to="/blog" className="nav-link">Blog</Link>
            <Link to="/how-it-works" className="nav-link">How it Works</Link>
            <Link to="/features" className="nav-link">Features</Link>
            <Link to="/contact" className="nav-link">Contact Us</Link>
          </nav>
          <a
            href="https://www.buymeacoffee.com/paperrocket"
            target="_blank"
            rel="noopener noreferrer"
            className="bmc-link"
            aria-label="Buy me a coffee"
          >
            ☕ Buy me a coffee
          </a>
        </div>
      </header>

      <main className="site-main">
        {children}
      </main>
    </div>
  );
};

export default Layout;
